const formatPrice = (price, postfix = '') => {
    if (!price) {
        return '';
    }
    return parseInt(price).toLocaleString('ru-RU', {
        style: 'currency',
        currency: 'RUB',
        minimumFractionDigits: 0

    }) + postfix;
}
export default formatPrice;